// extracted by mini-css-extract-plugin
module.exports = {"separateList":"CreateCategory_separateList__1j2P8","listProducts":"CreateCategory_listProducts__1uEqz","hrList":"CreateCategory_hrList__10f3K"};